/* @flow weak */
/**
 * ImageSupport is used to determine if a file's content type can be displayed
 * as an image within a browser.
 */

const TYPES = {
  'image/bmp': true,
  'image/gif': true,
  'image/jpeg': true,
  'image/png': true,
};

export function isSupportedType(contentType) {
  return contentType in TYPES ? TYPES[contentType] : false;
}



// WEBPACK FOOTER //
// ./src/lib/ImageSupport.js